import React  from 'react';

function DisplayStarIcons(rating) {
    const stars = [];
    for (let x = 0; x < rating; x++){
        stars.push(
            <span key={x}>
              <i className="fa fa-star" />
            </span>
          );
    }    

                      
    return stars;
    
  }
  
  export default DisplayStarIcons;